import { WidgetProps } from '@rjsf/utils'
import React, { useMemo } from 'react'
import { MultiSelectDropdown } from '../../../../../../components/MultiSelectDropdown/MultiSelectDropdown'
import { Form } from 'react-bootstrap'
import { CustomWidgetProps } from '../FormCitation/FormCitation'

export const CustomMultipleChoiceWidget: React.FC<WidgetProps> = (props) => {
  const { schema, onChange, value } = props
  const { isEditing, fieldContainerClass, citationButton } = props.options as CustomWidgetProps

  const enumValues = useMemo(() => {
    const items = schema?.items as { enum?: string[] }
    return items?.enum?.map((option) => option) || []
  }, [schema?.items])

  const options = useMemo(
    () =>
      enumValues.map((enumValue) => ({
        label: enumValue,
        value: enumValue,
        id: `option-${enumValue}`,
      })),
    [enumValues],
  )

  const selectedValues = useMemo(() => {
    if (Array.isArray(value)) {
      return value.map(String)
    }
    return value !== undefined && value !== null ? [value] : []
  }, [value])

  const selectedOptionIds = useMemo(
    () => options.filter((option) => selectedValues.includes(option.value)).map((option) => option.id),
    [options, selectedValues],
  )

  const handleSelectedChange = (selectedIds: string[]) => {
    const selectedValuesList = selectedIds.map((id) => options.find((option) => option.id === id)?.value)
    onChange(selectedValuesList)
  }

  return isEditing ? (
    <MultiSelectDropdown
      name='multiple-choice-widget'
      className='mw-100'
      options={options}
      initialSelectedOptions={selectedOptionIds}
      onSelectedChanged={handleSelectedChange}
    />
  ) : (
    <div className={fieldContainerClass}>
      <Form.Control
        type='text'
        value={selectedValues.length > 0 ? selectedValues : ''}
        placeholder='No relevant information detected'
        className='form-control border-0 disabled-contact-information-field zocks-border-color-gray-500'
        disabled={true}
      />
      {value ? citationButton : null}
    </div>
  )
}
